var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(-417 -4956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    transform: "translate(417 4956)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "youtube-svgrepo-com",
    d: "M23.619,8.584a2.5,2.5,0,0,0-1.778-1.79,60.646,60.646,0,0,0-7.825-.413,60.647,60.647,0,0,0-7.825.413,2.5,2.5,0,0,0-1.778,1.79A26.629,26.629,0,0,0,4,13.417a26.817,26.817,0,0,0,.413,4.858,2.5,2.5,0,0,0,1.778,1.753,60.637,60.637,0,0,0,7.825.413,60.636,60.636,0,0,0,7.825-.413,2.5,2.5,0,0,0,1.778-1.753,26.818,26.818,0,0,0,.413-4.858A26.623,26.623,0,0,0,23.619,8.584ZM11.963,16.409V10.45l5.246,2.967L11.963,16.4Z",
    transform: "translate(421.984 4961.653)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.91a48c4339c5b09619af8c598d783a3f.svg";
export { ForwardRef as ReactComponent };